import controller from './droppable-target-controller';

const DroppableTargetComponent: angular.IComponentOptions = {
  controller,
  controllerAs: 'ctrl',
  transclude: true,
  bindings: {
    hasValue: '<',
    onUpdate: '&',
  },
  template: `
    <div class="drag-drop-target" ng-class="{'has-value': ctrl.hasValue}" ng-transclude></div>
  `,
};

export { DroppableTargetComponent };
